import { FC, useState } from 'react';
import cn from 'classnames';
import { Application } from '@raydiant/api-client-js';
import Hidden from 'raydiant-elements/layout/Hidden';
import { MarketplaceApplication } from '../../pages/MarketplacePage/MarketplacePage';
import ApplicationIcon from '../../pages/LibraryPage/v2/components/ApplicationIcon';
import Text from '@raydiant/raydial/components/Text';
import { Check } from '@raydiant/raydial/components/Icons';
import ApplicationCardV2 from '../../pages/ApplicationsPage/ApplicationCardV2';
import Button from '@raydiant/raydial/components/Button';

interface MarketplaceCardProps {
  application: MarketplaceApplication;
  onLearnMoreClick?: (app: string) => void;
  onInstallClick?: () => void;
  onClick?: (application: Application) => void;
  auto?: boolean;
}

const MarketplaceCard: FC<MarketplaceCardProps> = ({
  application,
  onClick,
}) => {
  const [overlay, setOverlay] = useState<boolean>(false);
  const { currentAppVersion, name, checked } = application;

  const cta = currentAppVersion.name || name;

  const renderDesktopCard = () => {
    return (
      <div
        className={cn(
          'h-[185px] rounded-[20px] shadow border-2 border-grey-100 flex-col justify-start items-start inline-flex cursor-pointer',
        )}
        onMouseEnter={() => setOverlay(true)}
        onMouseLeave={() => setOverlay(false)}
        onClick={onClick ? () => onClick(application) : undefined}
      >
        <div className="relative w-[220px] h-[125px] p-4 rounded-t-[17px] justify-between flex bg-center bg-no-repeat bg-cover">
          <div
            className="absolute inset-0 rounded-t-[17px] bg-center bg-cover bg-no-repeat"
            style={{
              backgroundImage: `url(${application.currentAppVersion.thumbnailUrl})`,
            }}
          />
          {checked && (
            <div className="z-[2]">
              <div className="bg-green-200 w-6 h-6 rounded-xl flex items-center justify-center">
                <Check className="text-white" />
              </div>
            </div>
          )}
          {overlay && (
            <div className="absolute inset-0 bg-black/50 rounded-t-[17px] z-[3] flex items-center justify-center">
              <Button
                variant="unstyled"
                className="bg-primary text-white px-4 py-2 rounded-2xl"
                onPress={() => onClick?.(application)}
              >
                View Details
              </Button>
            </div>
          )}
        </div>
        <div className="w-[220px] h-[60px] px-4 bg-white rounded-b-[20px] flex-col justify-center items-start gap-2.5 flex">
          <div className="self-stretch justify-start items-center gap-2 inline-flex">
            <ApplicationIcon url={application.currentAppVersion.iconUrl} />
            <div className="grow shrink basis-0 text-gray-600 break-all line-clamp-2">
              <Text variant="body">{cta}</Text>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderMobileCard = () => {
    return (
      <ApplicationCardV2
        key={application.id}
        application={application}
        buttonClassName={
          'bg-primary-200 px-3 py-1 rounded-2xl text-white font-semibold'
        }
        buttonContent={<div>{checked ? 'PURCHASED' : 'GET'}</div>}
        onClick={onClick ? () => onClick(application) : () => {}}
      />
    );
  };

  if (!application) return null;

  return (
    <>
      <Hidden xsDown>{renderDesktopCard()}</Hidden>
      <Hidden smUp>{renderMobileCard()}</Hidden>
    </>
  );
};

export default MarketplaceCard;
